import { render, staticRenderFns } from "./RaisedList.vue?vue&type=template&id=5af4f2a2"
import script from "./RaisedList.vue?vue&type=script&lang=js"
export * from "./RaisedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports